import styled from 'styled-components';

import { Colors, Fonts, rem } from '../../../../themes';
import { TableTitlesType } from './Table';

type Props = {
  groupData: TableTitlesType[];
  onSignerSelect: (signerId: number) => void;
  onCancel: () => void;
};

function SignerSelectionModal({ groupData, onSignerSelect, onCancel }: Props) {
  return (
    <Container>
      <Title>Select a signer to send NDA to:</Title>
      <SignerList>
        {groupData.map(signer => (
          <SignerItem
            key={signer.actions.userId}
            onClick={() => onSignerSelect(signer.actions.userId)}
          >
            <SignerName>{signer.name}</SignerName>
            <SignerEmail>{signer.email}</SignerEmail>
            <SignerCompany>{signer.company}</SignerCompany>
          </SignerItem>
        ))}
      </SignerList>
      <ButtonContainer>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.div`
  padding: 20px;
  min-width: 400px;
`;

const Title = styled.h3`
  font-family: ${Fonts.Sofia};
  font-size: ${rem(14)};
  color: ${Colors.Black};
  margin-bottom: 20px;
  text-align: center;
`;

const SignerList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
`;

const SignerItem = styled.div`
  padding: 15px;
  border: 1px solid ${Colors.WeakGrey};
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${Colors.LightGrey};
    border-color: ${Colors.LightBlue};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const SignerName = styled.div`
  font-family: ${Fonts.Sofia};
  font-size: ${rem(14)};
  font-weight: 600;
  color: ${Colors.Black};
  margin-bottom: 5px;
`;

const SignerEmail = styled.div`
  font-family: ${Fonts.Sofia};
  font-size: ${rem(12)};
  color: ${Colors.DarkGrey};
  margin-bottom: 3px;
`;

const SignerCompany = styled.div`
  font-family: ${Fonts.Sofia};
  font-size: ${rem(12)};
  color: ${Colors.DarkGrey};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const CancelButton = styled.button`
  background-color: ${Colors.DarkBlue};
  color: ${Colors.White};
  border: 1px solid ${Colors.WeakGrey};
  padding: 10px;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    background-color: ${Colors.WeakGrey};
    color: ${Colors.Black};
  }
`;

export default SignerSelectionModal;
